import React from 'react';
import { Box } from '@skin-seoul/design-system';
import MobileAIChoiceProductCard from './cards/MobileAIChoiceProductCard';
const scrollableStyle = {
  scrollSnapType: 'x mandatory',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  scrollbarWidth: 'none'
} as const;
const AIChoiceProductsScrollSkeleton = ({
  count = 3
}: {
  count?: number;
} = {}) => {
  return <Box display="flex" overflowX="auto" gap={4} css={scrollableStyle} data-sentry-element="Box" data-sentry-component="AIChoiceProductsScrollSkeleton" data-sentry-source-file="AIChoiceProductsScroll.skeleton.tsx">
      {Array.from({
      length: count
    }).map((_, index) => <Box key={index} ml={index === 0 ? 'calc(50vw - 120px)' : 0} mr={index === count - 1 ? 'calc(50vw - 120px)' : 0} minWidth="240px" scrollSnapAlign="center" gap={0} display="flex">
          <MobileAIChoiceProductCard.Skeleton />
        </Box>)}
    </Box>;
};
export default AIChoiceProductsScrollSkeleton;